import React from "react";
import DownloadPdfButton from "../../../../../../common/buttons/downloadPdfButton";
import "./nav.style.scss";

function nav({ block, comparePdfButton, downloadPdfHandler, setStepNumber }) {
  let environment = process.env.NODE_ENV;

  return (
    <div
      className={`analyze-anlysis-navigation navbar text-uppercase ${
        block ? "blockSteps" : ""
      }`}
    >
      <ul
        className="nav nav-tabs top_nav head-menu"
        style={{
          marginBottom: "0",
          paddingTop: "15px",
          backgroundColor: "#eaf0f8",
        }}
      >
        <li className="active">
          <a
            href="#c1"
            data-toggle="tab"
            data-id="#c1"
            onClick={(e) => setStepNumber(e)}
          >
            Compare
          </a>
        </li>
        <li>
          <a
            href="#c2"
            data-toggle="tab"
            data-id="#c2"
            onClick={(e) => setStepNumber(e)}
          >
            Components
          </a>
        </li>
        <li>
          <a
            href="#c3"
            data-toggle="tab"
            data-id="#c3"
            onClick={(e) => setStepNumber(e)}
          >
            Performance
          </a>
        </li>
        <li>
          <a
            href="#c4"
            data-toggle="tab"
            data-id="#c4"
            onClick={(e) => setStepNumber(e)}
          >
            Statistics
          </a>
        </li>
        {/* {environment !== "production" ? ( */}
        <li>
          <a
            href="#c5"
            data-toggle="tab"
            data-id="#c4"
            onClick={(e) => setStepNumber(e)}
          >
            Simulation
          </a>
        </li>
        {/* ) : null} */}

        {/* <li>
          <a href="#c6" data-toggle="tab">
            Rebalance
          </a>
        </li> */}
      </ul>
      {comparePdfButton ? (
        <div className="nav_download_btn">
          <DownloadPdfButton
            handler={() => downloadPdfHandler()}
            btn_small={true}
          />
        </div>
      ) : null}
    </div>
  );
}

export default nav;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/analysis/navigation/nav.jsx